import { FilterOptions } from "../../types/observation";

interface EmployeesData {
  data: Array<{
    First_Name: string;
    Last_Name: string;
    GPID: string;
    Id?: string;
    Active_vs_Inactive?: string; // Added this field
    New_Hire?: number | string;
  }>;
}

interface Role {
  ROLE_NAME: string;
  ROLE_ID: string;
}

/**
 * Creates filter options for observation dropdowns
 * @param employees Employee data from Redux state
 * @param roles Role data from Redux state
 * @returns FilterOptions object for dropdown filters
 */
export const getDropDownfilterOptions = (
  employees: EmployeesData | undefined,
  roles: Role[] | undefined
): FilterOptions => {
  return {
    employee: [
      {
        key: "employee",
        label: "Employee",
        options:
          employees && employees.data.length > 0
            ? employees.data
                .filter((emp) => emp.Active_vs_Inactive === "Active") // Only include active employees
                // .filter((emp) => Number(emp.New_Hire) === 0) // Exclude new hires
                .map((emp) => ({
                  displayText: emp.First_Name + " " + emp.Last_Name || emp.GPID,
                  id: String(emp.Id || emp.GPID), // always string
                }))
            : [{ displayText: "No employees found", id: "none" }],
      },
    ],
    role: [
      {
        key: "role",
        label: "Role",
        options:
          roles && roles.length > 0
            ? roles.map((role) => ({
                displayText: role.ROLE_NAME,
                id: String(role.ROLE_ID), // always string
              }))
            : [{ displayText: "No roles found", id: "none" }],
      },
    ],
    observationType: [
      {
        key: "observationType",
        label: "Observation Type",
        options: [
          { displayText: "Pulse Check", id: "pulse_check" },
          { displayText: "Routine", id: "routine" },
          { displayText: "Full", id: "full" },
        ],
      },
    ],
    shift: [
      {
        key: "shift",
        label: "Shift",
        options: [
          { displayText: "1st", id: "first" },
          { displayText: "2nd", id: "second" },
          { displayText: "3rd", id: "third" },
        ],
      },
    ],
  } as FilterOptions;
};
